import React, { useEffect } from 'react';

import { Button, Grid, Stack } from '@sunwisesoftware/sunwise-ui';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ReactHookFormFroala } from 'common/components/form';
import ShowErrors from 'common/components/ShowErrors';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validateTerms';

const TermsForm = ({
    errors,
    initialValues,
    isFetchingTerms,
    isSaving,
    saveTerms,
}) => {
    const { t } = useTranslation();
    const { control, handleSubmit, reset, watch } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    useEffect(() => reset(initialValues), [initialValues]);

    const isDisabledButton =
        isEqual(initialValues, watch()) || isFetchingTerms || isSaving;

    return (
        <Stack component="form">
            <ReactHookFormFroala control={control} name="content" />

            <ShowErrors errors={errors} />

            <Grid container>
                <Grid size={{ xs: 'grow' }} textAlign="right">
                    <Button
                        disabled={isDisabledButton}
                        onClick={handleSubmit(saveTerms)}
                        sx={{ width: { md: 'auto', xs: '100%' } }}
                        type="button"
                        variant="outlined"
                    >
                        {isSaving ? t('Saving').concat('...') : t('Save')}
                    </Button>
                </Grid>
            </Grid>
        </Stack>
    );
};

TermsForm.propTypes = {
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isFetchingTerms: PropTypes.bool,
    isSaving: PropTypes.bool,
    saveTerms: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    errors: selectors.getSaveTermsErrors,
    initialValues: selectors.getInitialValuesTerms,
    isFetchingTerms: selectors.getIsFetchingTerms,
    isSaving: selectors.getIsSavingTerms,
});

const mapDispatchToProps = (dispatch) => ({
    saveTerms: (values) => dispatch(actions.saveTermsAndConditions(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TermsForm);
